import {
  useUserPermissionsQuery,
  useUserPermissionsStore,
} from "@coworker/app/src/hooks/useFlag";
import { useUserFromMsal } from "@coworker/apprestructured/src/shared/hooks/useUserFromMsal";
import { SimpleDefaultLoadingScreen } from "@coworker/apprestructured/src/shared/simple/SimpleLoading/SimpleDefaultLoadingScreen";
import { PropsWithChildren, useEffect } from "react";

export const UserPermissions = ({ children }: PropsWithChildren) => {
  const { uid } = useUserFromMsal();
  const { isLoading, isFetching, data } = useUserPermissionsQuery(uid);
  const setFlags = useUserPermissionsStore((state) => state.setFlags);

  const permissionsUserId = useUserPermissionsStore(
    (state) => state.permissionsUserId
  );
  const userPermissionsAreReady = Boolean(uid) && !isLoading && !isFetching;
  const userPermissionsAreStored = permissionsUserId === uid;

  useEffect(() => {
    if (!userPermissionsAreReady || userPermissionsAreStored) {
      return;
    }

    // Fail-closed: treat an empty/undefined response as "no permissions" to avoid an infinite loading state.
    setFlags(uid, data ?? []);
  }, [data, setFlags, uid, userPermissionsAreReady, userPermissionsAreStored]);

  if (!userPermissionsAreReady || !userPermissionsAreStored) {
    return <SimpleDefaultLoadingScreen />;
  }

  return <>{children}</>;
};
